export enum StreamSubView {
  Input = 'input',
  Output = 'output'
}
